/**
 * Build-time env reads.
 *
 * Vite inlines every VITE_* variable it knows about, and a Docker build that passes
 * `--build-arg VITE_ENTRA_CLIENT_ID=` inlines an EMPTY STRING rather than leaving the variable
 * undefined. `??` keeps that empty string, which is how a production build shipped an empty
 * MSAL clientId (AADSTS900144). Treat blank as unset everywhere.
 */
export function envOr(value: string | undefined | null, fallback: string): string {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  return trimmed.length > 0 ? trimmed : fallback;
}
